import { useMemo } from 'react';

import { Grid, Typography } from '@kc-console/common-ui';
import { useTranslation } from '@kc-console/core';

import { useRefinedProjectMenuState } from '../../../../hooks';
import MegaMenuGlobalSidebarProjectSelector from './MegaMenuGlobalSidebarProjectSelector';

const MegaMenuGlobalSidebarDesc = () => {
  const { t } = useTranslation();
  const { accessibleProjects } = useRefinedProjectMenuState();

  const hasAccessibleProject = useMemo(() => accessibleProjects?.length > 0, [accessibleProjects]);
  const projectSelectorTitle = useMemo(() => {
    return hasAccessibleProject
      ? t('layout:mega_menu.header.no_current_project_desc')
      : t('layout:mega_menu.header.no_accessible_project_desc');
  }, [hasAccessibleProject, t]);

  return (
    <Grid css={{ width: '100%' }} display={'flex'} gap={'4px'} flexDirection={'column'}>
      <Typography variant={'label/medium/md'} color={'text/weaker/default'}>
        {projectSelectorTitle}
      </Typography>
      {hasAccessibleProject && (
        <MegaMenuGlobalSidebarProjectSelector accessibleProjects={accessibleProjects} />
      )}
    </Grid>
  );
};

export default MegaMenuGlobalSidebarDesc;
